<template>
  <div :class="$attrs.class">
    <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
    <mask-input :id="id" ref="input" v-model="value" mask="#####-###" :clear-incomplete="true" v-bind="{ ...$attrs, class: null }" :class="{ error: error }" @input="searchCep($event.target.value)" />
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'
import MaskInput from '@/Shared/Fields/MaskInput'

export default {
  inheritAttrs: false,
  components: {
    MaskInput,
  },
  props: {
    id: {
      type: String,
      default() {
        return `cep-input-${uuid()}`
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    error: String,
    label: String,
    modelValue: [String, Number],
  },

  data() {
    return {
      value: this.$props.modelValue,
    }
  },

  emits: ['update:modelValue'],
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end)
    },
    async searchCep(cep) {
      if(cep.length == 9 && cep == this.value) {
        await fetch(
          `https://viacep.com.br/ws/` + cep + `/json/`
        ).then(res => {
          res.json().then(json => {
            this.$emit('updateAddress', json);
          });
        });
      }
      this.$emit('update:modelValue', cep);
    }
  },
}
</script>
